export type Breakpoints = {
  _: 0;
  sm: string;
  md: string;
  lg: string;
  0: string;
  1: string;
  2: string;
};

const partialBreakpoints: Partial<Breakpoints> = ['600px', '900px', '1200px'];

partialBreakpoints._ = 0;
partialBreakpoints.sm = partialBreakpoints[0];
partialBreakpoints.md = partialBreakpoints[1];
partialBreakpoints.lg = partialBreakpoints[2];

export const breakpoints: Breakpoints = partialBreakpoints as Breakpoints;
